// Widget registry - maps widgetId to component metadata
// Components are lazy-imported in DashboardGrid.js
// Types: 0/1/2 = Expert, 3 = Expert-EAD, 4/5 = Assistant

const widgetRegistry = {
  "kpi-cards": {
    title: "Indicateurs clefs",
    description: "Entretiens, SIM, mises à jour, audits",
    defaultSize: { xs: 12 },
    allowedTypes: [0, 1, 2, 3, 4, 5],
    allowedRoles: [0, 1, 2, 3, 4],
  },
  // satisfaction: {
  //   title: "Satisfaction Groupe",
  //   description: "Note et taux de réponse satisfaction",
  //   defaultSize: { xs: 12 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [0, 1, 2, 3, 4],
  // },
  // rendement: {
  //   title: "Rendement",
  //   description: "Rendement mois / mois (reçus, déposés, %)",
  //   defaultSize: { xs: 12 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [1, 2, 3, 4],
  // },
  ca: {
    title: "Chiffre d'affaires",
    description: "CA mois / mois sur 6 mois",
    defaultSize: { xs: 12 },
    allowedTypes: [0, 1, 2, 3, 4, 5],
    allowedRoles: [1, 2, 3, 4],
  },
  missions: {
    title: "Répartition compagnie",
    description: "Répartition des missions et du CA par compagnie",
    defaultSize: { xs: 12 },
    allowedTypes: [0, 1, 2, 3, 4, 5],
    allowedRoles: [1, 2, 3, 4],
  },
  "repair-rates": {
    title: "Indicateurs de réparation",
    description: "Taux de réparation des pièces cibles et taux de PRE",
    defaultSize: { xs: 12 },
    allowedTypes: [0, 1, 2, 3, 4, 5],
    allowedRoles: [0, 1, 2, 3, 4],
  },
  // podiums: {
  //   title: "Podiums",
  //   description: "Classement experts et agences",
  //   defaultSize: { xs: 12 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [1, 2, 3, 4],
  // },
  // alerts: {
  //   title: "Alertes",
  //   description: "Résumé des alertes et risques",
  //   defaultSize: { xs: 12, md: 6 },
  //   allowedTypes: [0, 1, 2],
  //   allowedRoles: [1, 3, 4],
  // },
  // "team-overview": {
  //   title: "Vue équipe",
  //   description: "Items en attente de l'équipe",
  //   defaultSize: { xs: 12 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [1, 2, 3, 4],
  // },
  // "personal-perf": {
  //   title: "Performance personnelle",
  //   description: "Mes indicateurs de performance",
  //   defaultSize: { xs: 12 },
  //   allowedTypes: [0, 1, 2],
  //   allowedRoles: [0],
  // },
  // "quick-actions": {
  //   title: "Accès rapides",
  //   description: "Liens vers les pages fréquentes",
  //   defaultSize: { xs: 12, md: 6 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [0, 1, 2, 3, 4],
  // },
  // "interview-progress": {
  //   title: "Progression entretiens",
  //   description: "État d'avancement des entretiens",
  //   defaultSize: { xs: 12, md: 6 },
  //   allowedTypes: [0, 1, 2, 3, 4, 5],
  //   allowedRoles: [0, 1, 2, 3, 4],
  // },
};

export const getAvailableWidgets = (type, role) => {
  const t = Number(type);
  const r = Number(role);
  return Object.entries(widgetRegistry)
    .filter(
      ([, widget]) =>
        widget.allowedTypes.includes(t) && widget.allowedRoles.includes(r),
    )
    .map(([id, widget]) => ({ id, ...widget }));
};

export default widgetRegistry;
